"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _Advanced = _interopRequireDefault(require("./Advanced"));

var _Basic = _interopRequireDefault(require("./Basic"));

var _Mobile = _interopRequireDefault(require("./Mobile"));

var _modes = require("../../../constants/modes");

var _When = _interopRequireDefault(require("../../../../../common/components/When"));

var _Footer = _interopRequireDefault(require("../../../components/Footer"));

var _ModeSwitcher = _interopRequireDefault(require("./ModeSwitcher"));

require("../styles/_order-clips.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OrderClips = /*#__PURE__*/function (_Component) {
  _inherits(OrderClips, _Component);

  var _super = _createSuper(OrderClips);

  function OrderClips(props) {
    var _this;

    _classCallCheck(this, OrderClips);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onSave", (0, _lodash.default)(function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          shouldContinue = _ref.shouldContinue;

      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this$props, updateVideo, goToNextStage, onSave, canUpdateVideo, _this$state, videoClips, mode, _yield$onSave, error;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$props = _this.props, updateVideo = _this$props.updateVideo, goToNextStage = _this$props.goToNextStage, onSave = _this$props.onSave, canUpdateVideo = _this$props.canUpdateVideo;
                  _this$state = _this.state, videoClips = _this$state.videoClips, mode = _this$state.mode;

                  if (canUpdateVideo) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", void goToNextStage());

                case 4:
                  _context.next = 6;
                  return updateVideo({
                    clips: videoClips,
                    editingMode: mode
                  }, {
                    override: true
                  });

                case 6:
                  _context.next = 8;
                  return onSave();

                case 8:
                  _yield$onSave = _context.sent;
                  error = _yield$onSave.error;

                  if (!(error || !shouldContinue)) {
                    _context.next = 12;
                    break;
                  }

                  return _context.abrupt("return");

                case 12:
                  goToNextStage();

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "handleChangeMode", (0, _lodash.default)(function (_ref3) {
      var shouldClearClips = _ref3.shouldClearClips,
          letModalHandleClose = _ref3.letModalHandleClose;
      return function () {
        var updateVideo = _this.props.updateVideo;

        if (shouldClearClips) {
          updateVideo({}, {
            override: true
          });
        }

        _this.setState(function (_ref4) {
          var videoClips = _ref4.videoClips,
              preselectedMode = _ref4.preselectedMode,
              showChangeModeModal = _ref4.showChangeModeModal;
          return {
            mode: preselectedMode,
            videoClips: shouldClearClips ? [] : videoClips,
            showChangeModeModal: letModalHandleClose ? false : showChangeModeModal
          };
        }, _this.onSave());
      };
    }, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return JSON.stringify(args);
    }));

    _defineProperty(_assertThisInitialized(_this), "onUpdateVideoClips", function (newVideoClips) {
      _this.setState({
        videoClips: newVideoClips
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectMode", function (index) {
      var setCommentFilterClip = _this.props.setCommentFilterClip;

      _this.setState(function (_ref5) {
        var videoClips = _ref5.videoClips,
            mode = _ref5.mode;
        var selectedMode = index === 0 ? _modes.BASIC : _modes.ADVANCED;
        var hasVideoClip = Boolean(videoClips.length);

        if (selectedMode === _modes.ADVANCED) {
          setCommentFilterClip(void 0);
        }

        return {
          preselectedMode: selectedMode,
          mode: hasVideoClip ? mode : selectedMode,
          showChangeModeModal: hasVideoClip
        };
      }, function () {
        var videoClips = _this.state.videoClips;

        if (videoClips.length) {
          return;
        }

        _this.onSave()();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleChangeModeModal", function () {
      _this.setState(function (_ref6) {
        var showChangeModeModal = _ref6.showChangeModeModal;
        return {
          showChangeModeModal: !showChangeModeModal
        };
      });
    });

    var editingMode = props.editingMode,
        _videoClips = props.videoClips;
    _this.state = {
      videoClips: _videoClips || [],
      mode: editingMode,
      showChangeModeModal: false
    };
    return _this;
  }

  _createClass(OrderClips, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          videoClips = _this$state2.videoClips,
          mode = _this$state2.mode,
          showChangeModeModal = _this$state2.showChangeModeModal,
          preselectedMode = _this$state2.preselectedMode;
      var _this$props2 = this.props,
          goBack = _this$props2.goBack,
          canUpdateVideo = _this$props2.canUpdateVideo,
          isCommentModalOpen = _this$props2.isCommentModalOpen,
          setCommentFilterClip = _this$props2.setCommentFilterClip,
          commentFilterClip = _this$props2.commentFilterClip,
          shouldShowPendingApprovalInformation = _this$props2.shouldShowPendingApprovalInformation,
          shouldShowPendingApprovalButtons = _this$props2.shouldShowPendingApprovalButtons,
          selectedDrawerAssets = _this$props2.selectedDrawerAssets;
      var Builder = mode === _modes.BASIC ? _Basic.default : _Advanced.default;
      var hasPreselectedAdvanced = preselectedMode === _modes.ADVANCED;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "order-clips"
        }, canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_commonReact.Autosave, {
          data: {
            videoClips: videoClips,
            mode: mode
          },
          functionToCall: this.onSave()
        }) : null, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
          className: "order-clips__warning-modal",
          visible: showChangeModeModal,
          title: "Are you sure?",
          onSave: this.handleChangeMode({
            shouldClearClips: preselectedMode === _modes.BASIC
          }),
          onClose: this.toggleChangeModeModal,
          saveText: preselectedMode === 'ADVANCED' ? 'KEEP CLIP ORDER' : 'CONTINUE ANYWAY'
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "order-clips__warning-modal__content"
        }, /*#__PURE__*/_react.default.createElement("p", null, hasPreselectedAdvanced ? 'We’ve noticed you’ve already ordered some clips in Basic mode. If you change to Advanced you won\'t be able to bring the order or comments back to Basic mode.' : 'Unfortunately you can\'t bring the clip order or comments from Advanced mode to Basic mode. If you switch, you\'ll have to start from scratch.'), /*#__PURE__*/_react.default.createElement(_When.default, {
          isTruthy: hasPreselectedAdvanced
        }, /*#__PURE__*/_react.default.createElement("p", null, "Do you want to use the selected order or start new in Advanced mode?")), /*#__PURE__*/_react.default.createElement(_When.default, {
          isTruthy: hasPreselectedAdvanced
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          small: true,
          onClick: this.handleChangeMode({
            shouldClearClips: true,
            letModalHandleClose: true
          })
        }, "START NEW")))), /*#__PURE__*/_react.default.createElement(_reactResponsive.default, {
          key: "order-clips-full",
          minWidth: 640
        }, /*#__PURE__*/_react.default.createElement(Builder, {
          videoClips: videoClips,
          assetIds: videoClips.map(function (clip) {
            return clip.assetId;
          }),
          onUpdateVideoClips: this.onUpdateVideoClips,
          canUpdateVideo: canUpdateVideo,
          isCommentModalOpen: isCommentModalOpen,
          setCommentFilterClip: setCommentFilterClip,
          commentFilterClip: commentFilterClip,
          selectedDrawerAssets: selectedDrawerAssets
        })), /*#__PURE__*/_react.default.createElement(_reactResponsive.default, {
          key: "order-clips-mobile",
          maxWidth: 639
        }, /*#__PURE__*/_react.default.createElement(_Mobile.default, null)), /*#__PURE__*/_react.default.createElement(_Footer.default, {
          buttonText: canUpdateVideo ? 'SAVE & CONTINUE' : 'CONTINUE',
          onBackClick: goBack,
          nextDisabled: !videoClips.length,
          onNext: this.onSave({
            shouldContinue: true
          })
        }, !shouldShowPendingApprovalInformation && !shouldShowPendingApprovalButtons ? /*#__PURE__*/_react.default.createElement(_reactResponsive.default, {
          minWidth: 640
        }, /*#__PURE__*/_react.default.createElement(_ModeSwitcher.default, {
          selectedMode: mode,
          onSelectMode: this.onSelectMode,
          canUpdateVideo: canUpdateVideo
        })) : null))
      );
    }
  }]);

  return OrderClips;
}(_react.Component);

exports.default = OrderClips;